var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.showNewButton)?_c('div',{staticClass:"col-md-12 text-right"},[_c('p',[_c('router-link',{attrs:{"to":{name: 'users.create'}}},[_c('button',{staticClass:"btn btn-wd btn-icon btn-info"},[_c('i',{staticClass:"ti-plus"}),_vm._v(" Novo")])])],1)]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31f3063c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Users/Users.vue
// module id = T+Bo
// module chunks = 10